import { useState, useCallback } from 'react';

export type B255Mode = 'browse' | 'add' | 'edit';

export function useB255Mode() {
  const [mode, setMode] = useState<B255Mode>('browse');
  const isEditing = mode === 'add' || mode === 'edit';

  const enterAdd = useCallback(() => setMode('add'), []);
  const enterEdit = useCallback(() => setMode('edit'), []);
  const enterBrowse = useCallback(() => setMode('browse'), []);

  return { mode, setMode, isEditing, enterAdd, enterEdit, enterBrowse };
}
